const routeNames = {
    ADMIN_DASHBOARD: '/admin',
    DASHBOARD: '/home',
    CAMPAIGNS: '/home/campaigns',
    QUERIES: '/home/queries',
    PHYSICIANS: '/home/physicians',
    PHYSICIAN_ANALYSIS: '/home/physician_analysis',
    DATA_SOURCES: '/home/sources',
    DATA_SOURCES_HISTORY: '/home/sources/history',
    AFFINITY_HUB: '/home/affinity_hub',
    SETTINGS: '/home/settings',
    DIGITAL_PHYSICIAN_ENGAGEMENT: '/home/engagement/digital',
    DIGITAL_ENGAGEMENT: '/home/engagements/digital',
    TOTAL_PHYSICIAN_ENGAGEMENT: '/home/engagement/total',
    FIELD_PHYSICIAN_ENGAGEMENT: '/home/engagement/field',
    WEB_METRICS: '/home/web_metrics',
    TRIGGER: '/home/trigger/:trigger',
    TOP_PRESCRIBERS: '/home/top_prescribers',
    COMPANY_LIST: '/home/company_list',
    COMPANY_DETAILS: '/home/company_details',
    ALWAYS_ON: '/home/AlwaysOn',
    ERROR: '/home/error',
    FILES: 'home/files',
    TRIGGERS_SUMMARY: '/home/triggers_summary',
    PAID_MEDIA_ENGAGEMENT: '/home/engagement/paid_media_engagement',
    PAID_SEARCH_ENGAGEMENT: '/home/engagement/paid_search_engagement',
    WEBSITE_ENGAGEMENT: '/home/engagement/website_engagement',
    CREATIVES: 'home/creatives',
    PAID_SEARCH: '/home/PaidSearch',
};

export default routeNames;
